import React from 'react';
import { AlertCircle, CheckCircle, Globe, TrendingUp } from 'lucide-react';

const ProblemSolution = () => {
  return (
    <section className="problem-solution-section">
      <div className="section-container">
        {/* Problem */}
        <div className="problem-block">
          <div className="problem-header">
            <AlertCircle className="problem-icon" size={48} />
            <h2 className="section-title">
              Muchos negocios aún no tienen una web profesional
            </h2>
          </div>
          
          <div className="problem-grid">
            <div className="problem-card">
              <p className="problem-text">
                Muchos restaurantes y negocios dependen únicamente de Instagram para mostrar sus servicios
              </p>
            </div>
            <div className="problem-card">
              <p className="problem-text">
                Los clientes buscan en Google antes de elegir dónde comer o comprar
              </p>
            </div>
            <div className="problem-card">
              <p className="problem-text">
                Sin una web profesional, se pierden oportunidades valiosas de venta cada día
              </p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="solution-divider"></div>

        {/* Solution */}
        <div className="solution-block">
          <div className="solution-header">
            <CheckCircle className="solution-icon" size={48} />
            <h2 className="section-title">
              LTechSolutions crea páginas web modernas que muestran tu negocio de la mejor manera
            </h2>
          </div>

          <div className="solution-features">
            <div className="solution-feature">
              <Globe className="feature-icon" size={32} />
              <div>
                <h3 className="feature-title">Presencia Digital Profesional</h3>
                <p className="feature-description">
                  Un sitio web que transmite confianza y profesionalismo a tus clientes potenciales
                </p>
              </div>
            </div>

            <div className="solution-feature">
              <TrendingUp className="feature-icon" size={32} />
              <div>
                <h3 className="feature-title">Atrae Más Clientes</h3>
                <p className="feature-description">
                  Aparece en Google y da a conocer tu negocio a personas que están buscando activamente
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
